import { Component, Host, h, Prop, Event, EventEmitter, Watch, State, Method } from '@stencil/core';
declare var window;
@Component({
  tag: 'location-filters',
  styleUrl: 'location-filters.scss',
  shadow: true,
})
export class LocationFilters {
  @Prop() filterGroups: { [key: string]: any[] } = {};
  @Prop() filterGroupTitles: { [key: string]: string } = {};
  @Prop({ mutable: true }) selectedFilterIds: { [key: string]: string[] } = {};

  @State() expandedGroupIndices: number[] = [];

  @Event() applyFilters: EventEmitter;

  getTitleForKey(key: string): string {
    return this.filterGroupTitles[key] || key;
  }

  handleToggleClick(index: number) {
    let expandedGroupIndices = [...this.expandedGroupIndices];
    let existingIndex = this.expandedGroupIndices.indexOf(index);
    console.log(expandedGroupIndices);
    if (existingIndex > -1) {
      expandedGroupIndices.splice(existingIndex, 1);
      this.expandedGroupIndices = [...expandedGroupIndices];
    } else {
      this.expandedGroupIndices = [...expandedGroupIndices, index];
    }
  }

  handleCheckboxClick(key, filter, wasChecked) {
    let callback = `handleCheckboxClick${key}`;
    if (this[callback] && 'function' === typeof this[callback]) {
      return this[callback](key, filter, wasChecked);
    }
    if (wasChecked) {
      this.selectedFilterIds = {
        ...this.selectedFilterIds,
        [key]: [...this.selectedFilterIds[key].filter((i: any) => i !== filter.Id)],
      };
    } else {
      this.selectedFilterIds = {
        ...this.selectedFilterIds,
        [key]: [...this.selectedFilterIds[key], filter.Id],
      };
    }
    this.onClickApplyFilters();
    this.removeHash();
  }

  handleCheckboxClickLocationTypes(key, filter, checked) {
    if (checked) {
      this.selectedFilterIds = {
        ...this.selectedFilterIds,
        [key]: [],
      };
    } else {
      this.selectedFilterIds = {
        ...this.selectedFilterIds,
        [key]: [filter.Id],
      };
    }
    this.onClickApplyFilters();
    this.removeHash();
  }

  onClickApplyFilters() {
    this.applyFilters.emit(this.selectedFilterIds);
  }

  filterGroupCheckboxHTML(filter, key) {
    let checked =
      this.selectedFilterIds[key] && this.selectedFilterIds[key].indexOf(filter.Id) > -1;
    return (
      <div class="filter-group-option">
        <label>
          <input
            type="checkbox"
            name={key}
            value={filter.Id}
            checked={checked}
            onInput={() => this.handleCheckboxClick(key, filter, checked)}
          />
          <i>
            <icon-check-box width="16" height="16" checked={checked} />
          </i>
          {filter.Title}
        </label>
      </div>
    );
  }
  clearFiltersHTML() {
    return (
      <a
        href="#clearFilters"
        class="clear"
        onClick={event => {
          event.preventDefault();
          this.clear();
        }}
      >
        Clear Filters
      </a>
    )
  }

  removeHash() {
    let url = new URL(window.location);
    if (url.hash) {
      history.pushState("", document.title, window.location.pathname + window.location.search);
    }

  }

  clear() {
    console.log("prepare await");
    (async () => {
      console.log("waiting");
      await customElements.whenDefined('location-search');
      const locationSearchElement = document.querySelector('location-search');
      if (locationSearchElement) {
        console.log('element');
        await locationSearchElement.clearAdditionalFilters();
      }
    })();

    this.removeHash();
  }
  filterGroupHTML(key: string, index: number) {
    let filters = this.filterGroups[key],
      selectedFilters = this.selectedFilterIds[key] || [],
      expanded = this.expandedGroupIndices.indexOf(index) > -1;
    return (
      <div class={index === 0 ? "filter-group border-top" : "filter-group"}>
        <button
          class="filter-group-toggle"
          aria-expanded={expanded ? 'true' : 'false'}
          onClick={() => this.handleToggleClick(index)}
        >
          {this.getTitleForKey(key)} {selectedFilters.length > 0 ? <span class="text-lighter fw-normal selectedFilterCount"><icon-dot width="16" height="16"></icon-dot> {selectedFilters.length}</span> : ''}

          <icon-chevron-down width="16" height="16" />
        </button>
        {expanded && (
          <div class="filter-group-options">
            {filters.map(filter => this.filterGroupCheckboxHTML(filter, key))}
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <Host>
        <div class="filters">
          <div class="text-light sub-header filter-header">
            <p>Filters</p>
            {this.clearFiltersHTML()}
          </div>
          {Object.keys(this.filterGroups).map((key, index) =>
            this.filterGroupHTML(key, index),
          )}
        </div>
        {/* <div class="buttons">
          <button type="button" onClick={() => this.onClickApplyFilters()}>
            <span>Apply filters</span>
            <icon-arrow width="20" height="20" />
          </button>
        </div> */}
      </Host>
    );
  }
}
